import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { FaAngleLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../../../redux/actions/adminActions";
import ImgChangeIcon from "../../../assets/images/camera-icon.png";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Loader from "../../../components/Loader/Loader";
import "react-circular-progressbar/dist/styles.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "../../new/new.scss";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { CopyToClipboard } from "react-copy-to-clipboard";
import PDF from "../../../assets/images/pdf.svg";
import { saveAs } from "file-saver";
import { useReactToPrint } from "react-to-print";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Close from "../../../assets/images/close-icon.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Viewuser = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [percentage, setPercentage] = useState("");
  const dispatch = useDispatch();
  const userView = useSelector((state) => state.userView);
  const { user } = userView;
  const [text, setText] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [get_user_id_proof_docs, set_Get_user_id_proof_docs] = useState([]);
  const [corpCountry, setCorpCountry] = useState([]);
  const [countryId, setCountryId] = useState();
  const [manager, setManager] = useState([]);
  const [manId, setManId] = useState();
  const [empDesignation, seEmpDesignation] = useState([]);
  const [empid, setEmpId] = useState();
  const [roleId, setRoleId] = useState();
  const [userRoles, setUserRole] = useState([]);
  const [visible, setVisible] = useState(false);
  const [score, setScore] = useState();
  const [submitDate, setSubmitDate] = useState();
  const [statusValue, setStatusValue] = useState();
  const [history, setHistory] = useState([]);
  const [isDataSelected, setDataSelected] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [roleError, setRoleError] = useState("");
  const handleClose = () => setOpen(false);

  let customer_id = userView?.user?.data?.id?.toString()?.padStart(8, "0");
  const d = new Date(user?.data?.updatedAt);
  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };
  useEffect(() => {
    dispatch(getUserDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (userView) {
      if (userView?.loading !== undefined) {
        setLoading(userView?.loading);
      }
      setPercentage(userView?.user?.data?.percentage?.percentage);
    }
  }, [userView]);

  function getformatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: customer_id + "-User-QnA",
  });

  const handleOpen = () => {
    setOpen(true);
  };

  //
  useEffect(() => {
    const getCountry = async () => {
      await axios
        .get(process.env.REACT_APP_API + "get-country")
        .then((res) => setCorpCountry(res.data.data))
        .catch((err) => console.log(err));
    };
    getCountry();
    viewHistory();
  }, []);

  const handleCorpCountry = (e) => {
    const getCounryId = e.target.value;
    if (!getCounryId) {
      setError("This field is required");
    } else {
      setError("");
      setCountryId(getCounryId);
      getState(getCounryId);
    }
  };

  const handleRoleChange = (event) => {
    const value = event.target.value;

    // Validate if the selected value is not empty
    if (!value) {
      setRoleError("This filed is required");
    } else {
      setRoleError("");
      setRoleId(value);
    }
  };

  const handleCorpState = (e) => {
    const getStateId = e.target.value;
    setManId(getStateId);
  };

  const getState = async (country_id) => {
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-list-of-employees",
      headers: {
        "x-access-token": token,
      },
      data: {
        limit: 500,
        page: 1,
        country_id: country_id,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data.rows;
        setManager(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const checkVisible = () => {
    setVisible(false);
    setStartDate("");
    setEndDate("");
  };

  const downloadFileAtUrl = (url) => {
    const url1 = url?.document_name;
    // const fileName = "nationalid.png";
    const fileName = url1.split("/").pop();
    saveAs(url1, fileName);
    // const aTag = document.createElement("a");
    // aTag.href = url;
    // aTag.setAttribute("download", fileName);
    // document.body.appendChild(aTag);
    // aTag.click();
    // aTag.remove();
  };

  useEffect(() => {
    if (userView) {
      setValue("firstname", userView?.user?.data?.firstname);
      setValue("lastname", userView?.user?.data?.lastname);
      setValue("email", userView?.user?.data?.email);
      setValue("mobile", userView?.user?.data?.phone);
      setValue("address", userView?.user?.data?.current_address);
      setValue("city", userView?.user?.data?.city);
      setValue("postal", userView?.user?.data?.postal_code);
      setValue("country", userView?.user?.data?.user_country?.country_name);
      setValue("state", userView?.user?.data?.user_state?.state_name);
      setValue("gender", userView?.user?.data?.gender);
      setValue("dob", getformatDate(userView?.user?.data?.dob));
      setValue("occupation", userView?.user?.data?.occupation);
      setValue("employer", userView?.user?.data?.employer);
      setValue("marriedStatus", userView?.user?.data?.marital_status);
      setScore(userView?.user?.data?.score);
      setSubmitDate(userView?.user?.data?.QnASubmitedAt);
      set_Get_user_id_proof_docs(userView?.user?.data?.documents);
      setValue("sin", userView?.user?.data?.sin);
      setValue(
        "address_since_six_months",
        userView?.user?.data?.address_since_six_months
      );

      setValue("note", userView?.user?.data?.comp_verification_error_message);
      setValue("country_of_birth", userView?.user?.data?.country_of_birth);
      setValue("city_of_birth", userView?.user?.data?.city_of_birth);
      setValue("persona_status", userView?.user?.data?.isVerified);
      setValue(
        "persona_note",
        userView?.user?.data?.verification_error_message ?? ""
      );
      if (userView?.user?.data?.comp_isIdExpired) {
        setValue("KYC_status", "EXPIRED");
      } else if (
        userView?.user?.data?.comp_verification_error_message !== null
      ) {
        setValue("KYC_status", "REJECTED");
      } else if (userView?.user?.data?.comp_isVerified) {
        setValue("KYC_status", "VERIFIED");
      }
    }
  }, [userView]);

  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const approveUsers = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to UnBlock this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, UnBlock user!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id.userId,
            userstatus: 1,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is Unblocked Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error.response !== "" && error.response.data.message !== "") {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error.response.data.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not UnBlocked", "error");
      }
    });
  };

  const rejectUsers = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Block this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Block user!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id.userId,
            userstatus: 0,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is Blocked Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error.response !== "" && error.response.data.message !== "") {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error.response.data.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not Blocked", "error");
      }
    });
  };

  const approvePersona = async () => {
    const token = localStorage.getItem("accessToken");

    try {
      setLoading(true);
      // Create a FormData object
      let data1 = getValues();
      const formData = new FormData();
      formData.append("comp_isVerified", data1?.persona_status);
      formData.append("verification_error_message", data1?.persona_note);
      formData.append("userId", id?.userId);
      // API call to update user details
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "admin/update-user-details",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });
      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/users");
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error?.response?.data?.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  const onSubmitData = async (data) => {
    let tempData = getValues();

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-kyc-status",
      headers: {
        "x-access-token": token,
      },
      data: {
        userId: id.userId,
        kyc_status: tempData?.KYC_status,
        kyc_reason: tempData?.note,
      },
    };

    await axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status == 200) {
          Swal.fire({
            title: "Updated Successfuly",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navigate("/users");
        }
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
    // setDataSelected(true);
  };

  const disablePastDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  };
  const deleteFunction = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id.userId,
            is_deleted: 1,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is deleted Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error.response !== "" && error.response.data.message !== "") {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error.response.data.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not deleted", "error");
      }
    });
  };

  // const getImagesArray = () => {

  //   const images = user?.data?.documents?.map((file) => {
  //     console.log("extensions", file?.document_name?.split(".").pop());
  //     const extension = file?.document_name?.split(".").pop();
  //     if (
  //       extension == "png" ||
  //       extension == "jpg" ||
  //       extension == "jpeg" ||
  //       extension == "PNG"
  //     ) {
  //       return {
  //         image: file?.document_name,
  //         files: { name: file?.document_name },
  //       };
  //     } else if (extension == "pdf") {
  //       return { image: "PDF", files: { name: file.document_name } };
  //     }
  //   });
  //   set_Get_user_id_proof_docs(images);

  //   // console.log("images", images);
  // };

  // useEffect(() => {
  //   getImagesArray();
  // }, [user]);

  const getCouponCode = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-coupon-code",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id.userId,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response?.data?.data?.coupon;
        const date1 = response?.data?.data?.active_from?.substring(0, 10);
        const date2 = response?.data?.data?.active_to?.substring(0, 10);
        setText(data);
        setStatusValue(response?.data?.data);
        setVisible(true);
        setStartDate(date1);
        setEndDate(date2);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getEmployesDesignationRoles = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url:
        process.env.REACT_APP_API +
        "get-employee-designation-systemrole-country",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id?.userId,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response?.data?.data;
        setCountryId(data?.country_id);
        setManId(data?.reporting_user_id);
        setEmpId(data?.designation_id);
        setRoleId(data?.role_id);
        if (data?.country_id) {
          getState(data?.country_id);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getCouponCode();
    getEmployesDesignationRoles();
    getDesignations();
    getRoles();
  }, []);

  const getDesignations = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-rolesdesignation-listing",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data.rows;
        seEmpDesignation(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getRoles = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-roleslisting",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data;
        setUserRole(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const viewHistory = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-user-kycdetail-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id.userId,
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        setHistory(response?.data?.data?.rows);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "add-designation-system-role",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id.userId,
        role_id: roleId,
        designation_id: empid,
        country_id: countryId,
        reporting_user_id: manId,
      },
    };
    if (!countryId && !roleId) {
      setError("This field is required");
      setRoleError("This field is required");
    } else {
      setLoading(true);
      axios(config)
        .then(function (response) {
          setLoading(false);
          if (response.data.status == 200) {
            Swal.fire({
              title: response.data.message,
              timer: 2500,
              timerProgressBar: true,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
            });
          }
        })
        .catch(function (error) {
          setLoading(false);
          console.log(error);
        });
    }
  };

  const AssignReferral = () => {
    let date = new Date();
    let current_date =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    let edate = "2050-04-27";
    setLoading(true);
    var config = {};
    if (visible === true) {
      config = {
        method: "post",
        url: process.env.REACT_APP_API + "create-referral",
        headers: {
          "x-access-token": token,
        },
        data: {
          user_id: id.userId,
          active_from: startDate,
          active_to: endDate,
        },
      };
    } else {
      config = {
        method: "post",
        url: process.env.REACT_APP_API + "create-referral",
        headers: {
          "x-access-token": token,
        },
        data: {
          user_id: id.userId,
          active_from: current_date,
          active_to: edate,
        },
      };
    }

    axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status == 200) {
          Swal.fire({
            title: response.data.message,
            timer: 4500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navigate("/users");
        }
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error?.response?.data?.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      });
  };

  const disableReferral = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Disable this referral code!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Disable code!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + `referal/disable/${text}`,
          headers: {
            "x-access-token": token,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "Referral code is disabled Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error.response !== "" && error.response.data.message !== "") {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error.response.data.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Referral code is not disabled", "error");
      }
    });
  };
  const enableReferral = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Active this referral code!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Active code!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + `referal/enable/${text}`,
          headers: {
            "x-access-token": token,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "Referral code is Active Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error.response !== "" && error.response.data.message !== "") {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error.response.data.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Referral code is not enabled", "error");
      }
    });
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate("/users")} />
          </span>
          <h1 className="view-page-tittle">View User</h1>
        </div>

        <div className="bottom user-view">
          <div className="left">
            <div className="profile-pic-div userPercentage">
              <img
                src={
                  user?.data?.profilePic == null
                    ? ProfilePic
                    : user?.data?.profilePic
                }
                alt=""
                className="setting-profile userImage"
              />
              <CircularProgressbar
                value={percentage}
                strokeWidth={5}
                styles={buildStyles({
                  textColor: "red",
                  pathColor: percentage > 50 ? "#3e98c7" : "#ff9f9f",
                  // trailColor: "red"
                })}
              />
            </div>
            <p className="entity-type">{user?.data?.entity_type}</p>

            <p className="last-updatedAt">
              {d?.toDateString() + ", " + d?.getHours() + ":" + d?.getMinutes()}
            </p>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  disabled={true}
                  {...register("firstname")}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  disabled={true}
                  {...register("lastname")}
                  placeholder="Enter Last Name"
                />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  {...register("email")}
                  placeholder="Enter Email"
                />
              </div>

              <div className="formInput">
                <label>Mobile</label>
                <input
                  type="text"
                  name="mobile"
                  disabled={true}
                  {...register("mobile")}
                  placeholder="Enter Mobile"
                />
              </div>
              <div className="formInput">
                <label>Address</label>
                <input
                  type="text"
                  name="address"
                  disabled={true}
                  {...register("address")}
                  placeholder="Enter Address"
                />
              </div>
              <div className="formInput">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  disabled={true}
                  {...register("city")}
                  placeholder="Enter City"
                />
              </div>

              <div className="formInput">
                <label>Country</label>
                <input
                  type="text"
                  name="country"
                  disabled={true}
                  {...register("country")}
                  placeholder="Enter Country"
                />
              </div>
              <div className="formInput">
                <label>State/Province</label>
                <input
                  type="text"
                  name="state"
                  disabled={true}
                  {...register("state")}
                  placeholder="Enter State"
                />
              </div>
              <div className="formInput">
                <label>Postal Code</label>
                <input
                  type="text"
                  name="postal"
                  disabled={true}
                  {...register("postal")}
                  placeholder="Enter Postal Code"
                />
              </div>
              {/* <div className="formInput">
                <label>Gender</label>
                <input
                  type="text"
                  name="gender"
                  disabled={true}
                  {...register("gender")}
                  placeholder="Enter Gender"
                />
              </div>
              <div className="formInput">
                <label>Marital Status</label>
                <input
                  type="text"
                  name="marriedStatus"
                  disabled={true}
                  {...register("marriedStatus")}
                  placeholder="Enter Marital Status"
                />
              </div> */}
              <div className="formInput">
                <label>DOB</label>
                <input
                  type="date"
                  name="dob"
                  // disabled={true}
                  {...register("dob")}
                  placeholder="MM/DD/YYYY"
                />
              </div>
              <div className="formInput">
                <label>VAT # / TIN / SIN / CF</label>
                <input
                  type="text"
                  name="sin"
                  disabled={true}
                  {...register("sin")}
                  placeholder="Enter SIN"
                />
              </div>
              <div className="formInput">
                <label>Address Since Six Months</label>
                <input
                  type="text"
                  name="address_since_six_months"
                  disabled={true}
                  {...register("address_since_six_months")}
                />
              </div>
              <div className="formInput">
                <label>Country of Birth</label>
                <input
                  type="text"
                  name="country_of_birth"
                  disabled={true}
                  {...register("country_of_birth")}
                />
              </div>
              <div className="formInput">
                <label>City of Birth</label>
                <input
                  type="text"
                  name="city_of_birth"
                  disabled={true}
                  {...register("city_of_birth")}
                />
              </div>

              <div className="formInput"></div>
              <div className="roleDesiBlock">
                <hr></hr>
                <h3>User Verification Documents</h3>
                <div className="user-que-main-div">
                  <h4 className="user-que-subtitle">Employment Information</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">
                        Type of Investor <i>(Individual)</i>:
                      </span>
                      <span class="itemValue">
                        {user?.data?.type_of_investor}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Status of employment:</span>
                      <span class="itemValue">
                        {user?.data?.employment_status}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Years Employed:</span>
                      <span class="itemValue">
                        {user?.data?.employment_year == null
                          ? "N/A"
                          : user?.data?.employment_year}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Occupation:</span>
                      <span class="itemValue">{user?.data?.occupation}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Employer/Company:</span>
                      <span class="itemValue">{user?.data?.employer}</span>
                    </div>

                    <div class="detailItem">
                      <span class="itemKey">Approximate Annual Income:</span>
                      <span class="itemValue">{user?.data?.annual_income}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Political Person Name:</span>
                      <span class="itemValue">
                        {user?.data?.politician_name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Source of funds:</span>
                      {Array.isArray(user?.data?.fund_source)
                        ? user.data?.fund_source?.map((fund) => (
                            <li class="itemValue">{fund}</li>
                          ))
                        : ""}
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="user-que-main-div">
                  <h4 className="user-que-subtitle">Company Information</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">
                        Type of Investor <i>(Corporate)</i>:
                      </span>
                      <span class="itemValue">
                        {user?.data?.comp_type_of_investor}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Company Name:</span>
                      <span class="itemValue">{user?.data?.comp__name}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Type of Sector:</span>
                      <span class="itemValue">
                        {user?.data?.comp_type_of_sector}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">VAT Number:</span>
                      <span class="itemValue">{user?.data?.comp_vat}</span>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="user-que-main-div">
                  <h4 className="user-que-subtitle">Bank Information</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">Bank Name:</span>
                      <span class="itemValue">
                        {user?.data?.user_banking_details[0]?.bank_name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">IBAN:</span>
                      <span class="itemValue">
                        {user?.data?.user_banking_details[0]?.iban}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Swift Code:</span>
                      <span class="itemValue">
                        {user?.data?.user_banking_details[0]?.swift_code}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Transit Number:</span>
                      <span class="itemValue">
                        {user?.data?.user_banking_details[0]?.transit_number}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Account Number:</span>
                      <span class="itemValue">
                        {user?.data?.user_banking_details[0]?.account_number}
                      </span>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="user-que-main-div">
                  <h4 className="user-que-subtitle">Fiscal Residence</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">Country:</span>
                      <span class="itemValue">
                        {user?.data?.comp_country?.country_name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Province:</span>
                      <span class="itemValue">
                        {user?.data?.comp_state?.state_name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">City:</span>
                      <span class="itemValue">
                        {user?.data?.comp_city?.name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Company Address:</span>
                      <span class="itemValue">{user?.data?.comp_address}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Postal Code:</span>
                      <span class="itemValue">
                        {user?.data?.comp_postal_code}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Phone Number:</span>
                      <span class="itemValue">
                        {user?.data?.comp_phone_num}
                      </span>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="images verfication-document">
                  {get_user_id_proof_docs?.length > 0 ? (
                    get_user_id_proof_docs?.map((image, index) => (
                      <>
                        <div className="img-preview-div" key={index}>
                          <img
                            src={PDF}
                            alt=""
                            style={{
                              height: "70px",
                              widht: "50px",
                            }}
                            className="img-preview-img"
                          />
                          <div>
                            {decodeURI(image?.document_name).split("-").pop()}
                          </div>
                          <p className="doc-title">
                            <span>DOC Type:</span>
                            {image?.doc_title}
                          </p>
                          <p className="doc-title">
                            <span>DOC ID:</span>
                            {image?.document_id}
                          </p>
                          <p className="doc-title">
                            <span>Expiration:</span>
                            {image?.document_expiration}
                          </p>

                          <button
                            type="button"
                            className="approveButton downloadbtn"
                            onClick={() => {
                              downloadFileAtUrl(image);
                            }}
                          >
                            Download
                          </button>
                        </div>
                      </>
                    ))
                  ) : (
                    <h6>No Data Found</h6>
                  )}
                </div>
              </div>
              <div className="roleDesiBlock">
                <hr></hr>
                <div className="questionans-div">
                  <h3>User Questions and Answer</h3>
                  {user?.data?.QnA.length > 0 ? (
                    <button
                      type="button"
                      className="approveButton downloadbtn"
                      onClick={handlePrint}
                    >
                      Download
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="user-que-main-div" ref={componentRef}>
                  <h4 className="user-que-subtitle">User Details</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">Customer ID:</span>
                      <span class="itemValue">{customer_id}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Name:</span>
                      <span class="itemValue">
                        {user?.data?.firstname + " " + user?.data?.lastname}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Email:</span>
                      <span class="itemValue">{user?.data?.email}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Role:</span>
                      <span class="itemValue">
                        {user?.data?.isAccreditedInvestor == 3
                          ? "Accredited User"
                          : "Regular User"}
                      </span>
                    </div>
                    {score && (
                      <div class="detailItem">
                        <span class="itemKey">Score:</span>
                        <span class="itemValue">{score}</span>
                      </div>
                    )}
                    {submitDate && (
                      <div class="detailItem">
                        <span class="itemKey">Date Submitted:</span>
                        <span class="itemValue">
                          {submitDate?.substring(0, 10)}
                        </span>
                      </div>
                    )}
                  </div>

                  {userView?.user?.data?.individualVerificationStatus && (
                    <div className="questionblock">
                      <hr></hr>

                      <div className="title-topSection">
                        <h4 className="user-que-subtitle">
                          Individual Profile (Persona) Verification
                        </h4>
                      </div>

                      <div className="kycDetails-section">
                        <div className="formInput">
                          <strong className="itemKey">Status:</strong>
                          <p className="readonly-text">
                            {userView?.user?.data?.isVerified
                               == true
                              ? "Verified"
                              : "Unverified"}
                          </p>
                        </div>
                        <div className="formInput">
                          <strong>Remark/Note/Reason:</strong>
                          <p className="readonly-text">
                            {userView?.user?.data?.verification_error_message
                               || "-"}
                          </p>
                        </div>
                        {/* <div className="formInput">
                          <label>Status</label>
                          <select
                            name="persona_status"
                            {...register("persona_status", {
                              required: "Persona status is required",
                            })}
                          >
                            <option value="" disabled selected hidden>
                              Select
                            </option>
                            <option value={true}>Verified</option>
                            <option value={false}>Unverified</option>
                          </select>
                          {errors.persona_status && (
                            <div className="invalid-feedback">
                              {errors.persona_status.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput">
                          <label>Remark/Note/Reason</label>
                          <textarea
                            className="txtInput"
                            rows={3}
                            {...register("persona_note")}
                            name="note"
                          />
                        </div> */}

                        {/* <div className="kycUpdate-div">
                          <button
                            type="button"
                            className="approveButton"
                            onClick={approvePersona}
                            // disabled={!isDataSelected}
                          >
                            Update
                          </button>
                        </div> */}
                      </div>
                    </div>
                  )}

                  {userView?.user?.data?.corporateverificationStatus && (
                    <div className="questionblock">
                      <hr />

                      <div className="title-topSection">
                        <h4 className="user-que-subtitle">
                          Corporate Profile KYC Verification
                        </h4>
                        <button
                          type="button"
                          onClick={handleOpen}
                          className="editButton"
                        >
                          Log History
                        </button>
                      </div>

                      <div className="kycDetails-section">
                        <div className="formInput">
                          <label>Status</label>
                          <select
                            name="KYC_status"
                            {...register("KYC_status", {
                              required: "KYC status is required",
                            })}
                          >
                            <option value="" disabled selected hidden>
                              Select
                            </option>
                            <option value="VERIFIED">Verified</option>
                            <option value="REJECTED">Rejected</option>
                            <option value="EXPIRED">Expired</option>
                          </select>
                          {errors.KYC_status && (
                            <div className="invalid-feedback">
                              {errors.KYC_status.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput">
                          <label>Remark/Note/Reason</label>
                          <textarea
                            className="txtInput"
                            rows={3}
                            {...register("note")}
                            name="note"
                          />
                        </div>

                        <div className="kycUpdate-div">
                          <button
                            type="button"
                            className="approveButton"
                            onClick={onSubmitData}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="questionblock">
                    <hr></hr>

                    <div className="title-topSection">
                      <h4 className="user-que-subtitle">
                        Questions and Answer
                      </h4>
                      {user && user?.data?.score && (
                        <div>
                          <p className="user-statusTxt">
                            <span>Status: </span>
                            {user?.data?.score < 54
                              ? "Inappropriate"
                              : "Appropriate"}
                          </p>
                          <p className="user-statusTxt">
                            <span>Score: </span>
                            {user?.data?.score}
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="ques-ans-main">
                      <div className="ques-ans-new">
                        <h2>Bear Losess Test</h2>
                        {""}
                        {user && user.data.QnA.basic ? (
                          user?.data?.QnA?.basic?.map((ques, index) => (
                            <>
                              <div
                                className="detailItem companyInfo"
                                key={index}
                              >
                                <p className="questiontext">{ques?.question}</p>
                                <p className="itemValue">
                                  <b>Ans:</b>&nbsp;
                                  {ques?.answer}
                                </p>
                              </div>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                      <div className="ques-ans-old">
                        {" "}
                        <h2>Appropriateness Test</h2>
                        {""}
                        {user && user?.data?.QnA?.evaluation ? (
                          user?.data?.QnA?.evaluation?.map((que, index) => (
                            <>
                              <div
                                className="detailItem companyInfo"
                                key={index}
                              >
                                <p className="questiontext">
                                  {/* <span>Question {index + 1}.</span>&nbsp; */}
                                  {/* {que?.evaluation_investor_profile_question
                                ? que?.evaluation_investor_profile_question
                                    ?.q_en
                                : que?.question} */}
                                  {
                                    que?.evaluation_investor_profile_question
                                      ?.q_en
                                  }
                                </p>
                                <p className="itemValue">
                                  <b>Ans:</b>&nbsp;
                                  {/* {que?.answer} */}
                                  {/* {
                                que.evaluation_investor_profile_option
                                  ?.option_en
                              } */}
                                  {
                                    que?.evaluation_investor_profile_option
                                      ?.option_en
                                  }
                                </p>
                              </div>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>

                    {/* new q/a */}
                  </div>
                </div>
              </div>
              <div className="roleDesiBlock">
                <hr></hr>
                <h3>Roots Roles and Designations</h3>
                <div className="designationRole-wrapper">
                  <div className="formInput">
                    <label>Reporting Country</label>
                    {/* <Select
                      options={countries}
                      onChange={handleChangeCountry}
                      value={getCountry}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationCountry"
                      onChange={(e) => handleCorpCountry(e)}
                      value={countryId}
                    >
                      <option value="" disabled selected>
                        Select Country
                      </option>
                      {corpCountry?.map((getCon, index) => (
                        <option key={index} value={getCon?.id}>
                          {getCon?.country_name}
                        </option>
                      ))}
                    </select>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </div>
                  <div className="formInput">
                    <label>Reporting Manager</label>
                    {/* <Select
                      options={employees}
                      onChange={handleChangeManager}
                      value={getEmployee}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationState"
                      onChange={(e) => handleCorpState(e)}
                      value={manId}
                    >
                      <option value="" disabled selected>
                        Select Value
                      </option>
                      {manager.map((getName, index) => (
                        <option key={index} value={getName?.users?.id}>
                          {getName?.users?.firstname +
                            " " +
                            getName?.users?.lastname +
                            "--" +
                            getName?.designation?.designation}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="formInput">
                    <label>Root Designation</label>

                    {/* <Select
                      options={designations}
                      onChange={handleChangeDesignations}
                      value={getDesignation}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationState"
                      onChange={(e) => setEmpId(e.target.value)}
                      value={empid}
                    >
                      <option value="" disabled selected>
                        Select Value
                      </option>
                      {empDesignation.map((getName, index) => (
                        <option key={index} value={getName.id}>
                          {getName?.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="formInput">
                    <label>Roles</label>
                    {/* <Select
                      options={roles}
                      onChange={handleChangeRoles}
                      value={getRole}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationState"
                      onChange={handleRoleChange}
                      value={roleId}
                    >
                      <option value="" disabled selected>
                        Select Value
                      </option>
                      {userRoles.map((getRole, index) => (
                        <option key={index} value={getRole.id}>
                          {getRole?.role}
                        </option>
                      ))}
                    </select>
                    {roleError && <p style={{ color: "red" }}>{roleError}</p>}
                  </div>

                  <button
                    type="button"
                    className="approveButton"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>

              <div className="couponCode-div">
                <hr></hr>
                <div className="couponCode-wrapper">
                  <div className="formInput couponCodeInput">
                    <label>Referral Code</label>
                    <div className="withCopy">
                      <input
                        type="text"
                        value={text}
                        placeholder="Referral Code"
                        readOnly
                      />
                      {text && (
                        <CopyToClipboard text={text} onCopy={onCopyText}>
                          <div className="copy-area">
                            <ContentCopyIcon />
                            <span
                              className={`copy-feedback ${
                                isCopied ? "active" : ""
                              }`}
                            >
                              Copied!
                            </span>
                          </div>
                        </CopyToClipboard>
                      )}
                    </div>
                    {text && statusValue?.status == 1 ? (
                      <button
                        type="button"
                        className="declineButton"
                        onClick={disableReferral}
                      >
                        Disable Referral Code
                      </button>
                    ) : text && statusValue?.status == 0 ? (
                      <button
                        type="button"
                        className="approveButton"
                        onClick={enableReferral}
                      >
                        Enable Referral Code
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    {statusValue?.status !== 0 ? (
                      <div className="radio-wrapper">
                        <div className="radioWrap-div">
                          <input
                            type="radio"
                            id="active"
                            name="date-select"
                            value={visible}
                            onClick={() => setVisible(true)}
                          />
                            <label for="active">Active Range</label> {" "}
                        </div>
                        <div className="radioWrap-div">
                          <input
                            type="radio"
                            id="nonactive"
                            name="date-select"
                            value={visible}
                            onClick={() => checkVisible()}
                          />
                            <label for="nonactive">No Expiration</label>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {/* <div className="copyIcon-wrap">
                    <ContentCopyIcon />
                  </div> */}
                  <button
                    type="button"
                    // disabled={!startDate || !endDate}
                    // disabled={!startDate}
                    className="approveButton referral-CodeBtn"
                    onClick={AssignReferral}
                  >
                    Assign Referral Code
                  </button>
                </div>
              </div>
              {visible && (
                <div className="dateSec-wrap">
                  <div className="formInput couponCodeInput">
                    <label>Start Date</label>
                    <input
                      type="date"
                      name="startDate"
                      min={disablePastDate()}
                      {...register("startDate", {
                        required: "Start Date is required",
                      })}
                      placeholder="Enter Start Date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      checked
                    />
                    {errors.startDate && (
                      <div className="invalid-feedback">
                        {errors.startDate.message}
                      </div>
                    )}
                  </div>

                  <div className="formInput couponCodeInput">
                    <label>End Date</label>
                    <input
                      type="date"
                      name="endDate"
                      min={disablePastDate()}
                      {...register("endDate")}
                      placeholder="Enter End Date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                    {errors.endDate && (
                      <div className="invalid-feedback">
                        {errors.endDate.message}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* <div className="formInput"></div> */}

              <div className="submitButton">
                {userView?.user?.data?.userStatus == 1 ? (
                  <button
                    type="button"
                    className="approveButton"
                    onClick={rejectUsers}
                  >
                    Block
                  </button>
                ) : (
                  <button
                    type="button"
                    className="declineButton"
                    onClick={approveUsers}
                  >
                    Unblock
                  </button>
                )}
                <button
                  type="button"
                  className="declineButton"
                  onClick={deleteFunction}
                >
                  Delete
                </button>
              </div>
            </form>

            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal-popup">
                <div className="modal-top kycModal-top">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    KYC Activity
                  </Typography>
                  <Button className="closeBtn" onClick={() => setOpen(false)}>
                    <img src={Close} alt="close-icon" />
                  </Button>
                </div>
                <div className="kyclog-listing">
                  {history?.map((status, index) => {
                    const d = new Date(status?.timestamp);
                    return (
                      <Typography
                        id="modal-modal-description"
                        className="typography_kyc"
                        sx={{ mt: 1 }}
                      >
                        <div className="new">
                          <div className="newContainer">
                            <div
                              className="bottom"
                              style={{
                                boxShadow: "none",
                                margin: "2px",
                                padding: "0",
                              }}
                            >
                              <div className="right kycDetails-wrapper">
                                <form className="kyc-form">
                                  <div className="kycMain-wrapper">
                                    <div className="history-infoWrap">
                                      <Typography>
                                        {d?.getHours() +
                                          ":" +
                                          d?.getMinutes() +
                                          ", " +
                                          d?.toDateString()}{" "}
                                        &nbsp;
                                      </Typography>
                                      <Typography>
                                        {status?.KYC_status} &nbsp;
                                      </Typography>
                                    </div>

                                    <div className="remark-wrapper">
                                      <p> {status?.KYC_reason} &nbsp; </p>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Typography>
                    );
                  })}
                </div>
              </Box>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewuser;
